// الجدول الرئيسي — 13 عموداً حسب المواصفة (بما فيها الراتب الأساسي).
import { LEAVE_BADGE } from "./reportTokens";
import { esc, firstFive, formatCurrency, shortDate } from "./reportFormat";
import { chunk, pageFoot } from "./reportPages";
import { totalsRow } from "./reportTotalsRow";

const badges = (breakdown, L) =>
  Object.entries(breakdown || {})
    .filter(([, item]) => item.count > 0)
    .map(([kind, item]) => {
      const [bg, fg] = LEAVE_BADGE[kind] || LEAVE_BADGE.unpaid;
      const { shown, more } = firstFive(item.dates);
      const dates = shown.map(shortDate).join(" ") + (more ? " …" : "");
      return `<span class="badge" style="background:${bg};color:${fg}">${esc(L.leaveTypes[kind] || kind)} ${item.count}` +
        `${dates ? ` · ${esc(dates)}` : ""}</span>`;
    })
    .join("");

const leaveTotal = (breakdown) => Object.values(breakdown || {}).reduce((sum, i) => sum + (i.count || 0), 0);

const absenceLine = (dates) => {
  const { shown, more } = firstFive(dates);
  return shown.length ? `<div class="sub neg">${esc(shown.join(", "))}${more ? " …" : ""}</div>` : "";
};

const row = (e, L, { custom }) => {
  const c = e.currency;
  const weekendTone = e.paid_weekends < e.total_weekends ? "neg" : "pos";
  const mode = custom && e.work_mode ? ` · ${esc(e.work_mode === "remote" ? L.remote : L.office)}` : "";
  return `<tr>
    <td><span class="b">${esc(e.employee_name)}</span><div class="sub">${esc(e.branch_name)}${mode}</div></td>
    <td class="b">${esc(formatCurrency(e.base_salary, c))}</td>
    <td>${esc(formatCurrency(e.daily_rate, c))}</td>
    <td>${e.days_worked}</td>
    <td class="${weekendTone} b">${e.total_weekends}/${e.paid_weekends}</td>
    <td>${leaveTotal(e.leave_breakdown)}<div>${badges(e.leave_breakdown, L)}</div></td>
    <td class="${e.compensation_days > 0 ? "positive b" : ""}">${e.compensation_days}</td>
    <td class="b">${e.total_paid_days}</td>
    <td class="${e.absence_days > 0 ? "danger b" : ""}">${e.absence_days}${absenceLine(e.absence_dates)}</td>
    <td class="${e.late_count > 0 ? "danger b" : ""}">${e.late_count}</td>
    <td class="danger" title="${esc(e.deductions_breakdown)}">
      ${e.deductions_total ? `-${esc(formatCurrency(e.deductions_total, c))}` : esc(formatCurrency(0, c))}
      ${e.deductions_breakdown ? `<div class="sub danger">${esc(e.deductions_breakdown)}</div>` : ""}
    </td>
    <td class="danger">${e.advance_installment ? esc(formatCurrency(e.advance_installment, c)) : esc(L.none)}</td>
    <td class="b ${e.accumulated_salary < 0 ? "danger" : "positive"}">${esc(formatCurrency(e.accumulated_salary, c))}</td>
  </tr>`;
};

export const table = (data, L, options) => {
  const head = L.cols.map((label) => `<th>${esc(label)}</th>`).join("");
  const pages = chunk(data.employees.map((e) => row(e, L, options)));
  const foot = totalsRow(data, L);
  return pages
    .map((rows, i) => {
      const last = i === pages.length - 1;
      return `<div class="sheet">
        <table><thead><tr>${head}</tr></thead><tbody>${rows.join("")}</tbody>${last ? foot : ""}</table>
        ${last ? "" : pageFoot(i + 1, pages.length, L)}
      </div>${last ? "" : '<div class="pagebreak"></div>'}`;
    })
    .join("");
};

export const pageCount = (data) => chunk(data.employees).length;
